<template>
  <b-link class="link" :to="{ name: 'Home' }">
    <i class="bx bx-exit"> </i>
    Salir
  </b-link>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      username: process.env.VUE_APP_USER_ADMIN,
    };
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.link {
  display: flex;
  align-items: center;
  color: #052333;
  text-decoration: none;
}

@media screen and (max-width: 886px) {
  .dos {
    display: none;
  }
}

@media screen and (max-width: 763px) {
  .img {
    max-width: 97%;
  }
}
</style>
